<template>
  <div>
    <c-row>
      <c-col col="12">
        <loader v-show="loading" />
        <c-card>
          <c-card-header>
            <strong>Stock Opname</strong>
          </c-card-header>
          <c-card-body style="overflow: auto; min-height: 350px; padding-bottom: 50px;">
            <div class="form-group">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-6">
                    <label for="tanggal">Tanggal</label>
                    <span class="form-control">
                      {{ header.created_at }}
                    </span>
                  </div>
                  <div class="col-md-6">
                    <label for="tanggal">Catatan</label>
                    <input type="text" class="form-control" id="tanggal" placeholder="Contoh: Selisih"
                      v-model="header.notes">
                  </div>
                </div>
              </div>
            </div>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th width="50px">No</th>
                  <th>Produk</th>
                  <th width="100px">Stock Sistem</th>
                  <th width="100px">Stock Fisik</th>
                  <th width="100px"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(v, k) in products" :key="k">
                  <td>{{ k+1 }}</td>
                  <td>{{ v.product.name }}</td>
                  <td class="text-center">{{ v.product.qty }}</td>
                  <td class="text-center">{{ v.item.real_qty }}</td>
                  <td>...</td>
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td colspan="2">
                    <product-name-selector v-model="product" />
                  </td>
                  <td>
                    <span class="form-control text-right">{{product.qty}}</span>
                  </td>
                  <td>
                    <input type="text" v-model="priceFormat" class="form-control text-right" />
                  </td>
                  <td><button class="btn btn-success" @click="append(item)" :disabled="!product.id">Append</button></td>
                </tr>
              </tbody>
            </table>
          </c-card-body>
          <c-card-footer>
            <button class="btn btn-success" @click="save">Submit</button>
          </c-card-footer>
        </c-card>
      </c-col>
    </c-row>
  </div>
</template>
<script>
import Loader from '../../components/Loader.vue';
import ProductNameSelector from '../../components/ProductNameSelector.vue';
import { showErrorMessage } from '../../lib/helpers';
import { HTTPAUTH } from "../../lib/httplib";

export default {
  name: "CardList",
  components: {
    Loader,
    ProductNameSelector,
  },
  computed: {
    priceFormat: {
      get () {
        if (this.item && this.item.real_qty) {
          return this.item.real_qty.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
        return '0';
      },
      set (value) {
        this.item.real_qty = value.replace(/[^\d]/g, '');
      }
    }
  },
  data () {
    return {
      loading: false,
      data: [],
      paginate: {},
      product: {},
      products: [],
      item: {
        real_qty: 0
      },
      input: false,
      warranty_code: '',
      header: {
        created_at: moment().format("DD MMMM YYYY HH:mm:ss")
      }
    };
  },
  methods: {
    async append (item) {
      this.products.push({
        product: this.product,
        item: item
      });
      this.product = {}
      this.item = {
        real_qty: 0,
      }
    },
    async save () {
      HTTPAUTH.post(`/api/stock-adjustment`, { header: this.header, items: this.products }).then(() => {
        // this.header = {
        //   created_at: moment().format("DD MMMM YYYY HH:mm:ss")
        // }
        // this.products = []
        window.location.reload();
      }).catch(eres => {
        showErrorMessage(eres)
      })
    }
  },
};
</script>